function getDensities(label) {
    const isDens = /dens/.exec(label);
    if (isDens) {
        return [
            label.replace(/(?<name>.+)(?<separator>_|\s)density/, '$<name>$<separator>dens'),
            true,
        ];
    }
    else {
        return [label, false];
    }
}
const units = {
    C: 'F',
    I: 'A',
    V: 'V',
    R: 'Ohm',
    G: 'S',
    Q: 'C',
    F: 'Hz',
    T: 's',
};
export function appendUnits(data, knownUnits = {}) {
    for (const key in data) {
        let label = data[key].label.trim();
        const [densLabel, isDens] = getDensities(label);
        // The variable already has a default unit
        if (knownUnits[label]) {
            data[key].units = knownUnits[label];
        }
        // Infer the variables units based on the name
        else {
            const unit = units[label[0].toUpperCase()] || undefined;
            if (unit) {
                data[key].units = isDens ? `${unit}/mm` : unit;
            }
        }
        // Replaces density for dens
        if (isDens) {
            label = densLabel;
        }
        const labelUnits = data[key].units ? ` [${data[key].units}]` : '';
        data[key].label = label + labelUnits;
    }
    return data;
}
export function getLabels(analysis) {
    const { meta = {}, variables } = analysis.spectra[0];
    const [xLabel] = getDensities(meta['Output.Graph.XAxis.Data'] || variables.x.label);
    const [yLabel] = getDensities(meta['Output.Graph.YAxis.Data'].split(',')[0].trim() || variables.y.label);
    const scale = meta['Output.Graph.YAxis.Scale'].split(',')[0].trim().toLowerCase() ===
        'linear'
        ? 'linear'
        : 'log';
    return { xLabel, yLabel, scale };
}
//# sourceMappingURL=data:application/json;base64,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